import { defineMessages } from 'react-intl'

export default defineMessages({
  claimsPhoneNumbersPhone: {
    id: 'app.claims.phoneNumbers.phone',
    defaultMessage: 'Phone',
  },
  claimsPhoneNumbersEmergencyPhone: {
    id: 'app.claims.phoneNumbers.emergencyPhone',
    defaultMessage: 'Emergency phone',
  },
  claimsPhoneNumbersInsurer: {
    id: 'app.claims.phoneNumbers.insurer',
    defaultMessage: 'Insurer',
  },
  claimsPhoneNumbersBrokerage: {
    id: 'app.claims.phoneNumbers.brokerage',
    defaultMessage: 'Brokerage',
  },
  claimsPhoneNumbersAgency: {
    id: 'app.claims.phoneNumbers.agency',
    defaultMessage: 'Agency',
  },
  claimsPhoneNumbersNoRecordsFound: {
    id: 'app.claims.phoneNumbers.noRecordsFound',
    defaultMessage: 'No phones found',
  },
})
